export const MESSAGE_PUSHER = {
     CLAIM_SEAT: 'CLAIM_SEAT',
     EXPORT_REPORTING_URL: 'EXPORT_REPORTING_URL',
     UPDATE_HISTORICAL_STATUS: 'UPDATE_HISTORICAL_STATUS',
     UPDATE_USER_CERTIFICATE_LEVEL: 'UPDATE_USER_CERTIFICATE_LEVEL',
};

export const CHANNEL_PUSHER = {
     HUBSPOT_HISTORICAL_STATUS: 'channel-hubspot-historical-status',
     EXPORT_REPORTING_URL: 'channel-export-reporting-url',
};
